<template>
  <div id="Rahmen" v-on:mouseover="isOpen = true"  v-on:mouseleave="isOpen = false">
    <router-link style="color: inherit;" :to="link">
      <img v-if="title === 'Startseite'" style="height: 2em; float: left;" src="@/assets/LogoSchema.png" alt="Logo" />
      <div v-if="title !== 'Startseite'" style="font-size: 2em; float: left;">{{title}}</div>
      <div v-if="items" style="font-size: 2em; float: left; margin-left: 5px; padding-left: 3px; padding-right: 3px; background-color: #6e171d; color: #FFFFFF; border-radius: 1em;">+</div>
    </router-link>
    <transition name="fade" appear>
      <div id="subMenu" v-if="isOpen">
        <router-link v-for="item in items" :key="item.title" :to="item.link" id="subItem">
          {{item.title}}
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'DropdownPC',
    props: {
      title: {default: null},
      items: {default: null},
      link: {type: String, default: ''}
    },

    data () {
      return {
        isOpen: false
      }
    },

    methods: {

    },

    computed: {

    },

    mounted: function () {

    }
  }
</script>

<style scoped>

  #Rahmen {
    color: #6e171d;
    user-select: none;
    cursor: pointer;
    display: inline-block;
    border-bottom: 5px solid transparent;
    border-radius: 10px;
    padding: 5px 15px 0px 15px;
  }

  #Rahmen:hover {
    background-color: #6e171d;
    color: #FFFFFF;
    border-color: #98cb00;
  }

  #subMenu {
    position: fixed;
    width: inherit;
    left: 50%;
    margin-top: 3em;
    transform: translateX(-50%);
    background-color: #FFFFFF;
  }

  #subItem {
    color: #6e171d;
    user-select: none;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    border-radius: 10px;
    padding: 5px 15px 0px 15px;
    font-size: 1.5em;
  }

  #subItem::after{
    content: "\a";
    white-space: pre;
  }

  #subItem:hover {
    background-color: #6e171d;
    color: #FFFFFF;
    border-color: #98cb00;
  }

  .fade-leave-active {
    transition: all 0.2s 0.3s ease-out;
  }

  .fade-leave-to {
    opacity: 0;
  }

  a {
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/DropdownPC.vue